// Quality Framework Service - Service layer for quality framework API operations

import axiosInstance from "../instance/axiosInstance";
import { QUALITY_FRAMEWORK_ENDPOINTS } from "../endpoints/qualityFramework.endpoints";
import { handleApiError } from "../utils/errorHandler";

export const QualityFrameworkService = {
  // Get all quality framework requests
  getRequests: async () => {
    try {
      const response = await axiosInstance.get(
        QUALITY_FRAMEWORK_ENDPOINTS.GET_REQUESTS,
      );
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },

  // Assign preparer/reviewer users to a request
  assignUsers: async (payload) => {
    try {
      const response = await axiosInstance.post(
        QUALITY_FRAMEWORK_ENDPOINTS.ASSIGN_USERS,
        payload,
      );
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },

  // Get eligible reviewers for a request
  getEligibleReviewers: async () => {
    try {
      const response = await axiosInstance.get(
        QUALITY_FRAMEWORK_ENDPOINTS.GET_ELIGIBLE_REVIEWERS,
      );
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },

  // Get the population count for a period and area
  getPopulationCount: async (periodStartDate, periodEndDate) => {
    try {
      const response = await axiosInstance.get(
        QUALITY_FRAMEWORK_ENDPOINTS.GET_POPULATION_COUNT(
          periodStartDate,
          periodEndDate,
        ),
      );
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },

  // Identify the population details for the selected filters
  identifyPopulationDetails: async (payload) => {
    try {
      const response = await axiosInstance.post(
        QUALITY_FRAMEWORK_ENDPOINTS.IDENTIFY_POPULATION_DETAILS,
        payload,
      );
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },

  // Get checklist questions
  getChecklistQuestions: async () => {
    try {
      const response = await axiosInstance.get(
        QUALITY_FRAMEWORK_ENDPOINTS.GET_CHECKLIST_QUESTIONS,
      );
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },

  // Get checklist answers for an order request
  getChecklistAnswers: async (orderRequestId) => {
    if (!orderRequestId) {
      throw new Error("Order request ID is required");
    }

    try {
      const response = await axiosInstance.get(
        QUALITY_FRAMEWORK_ENDPOINTS.GET_CHECKLIST_ANSWERS(orderRequestId),
      );
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },

  // Submit checklist answers
  submitChecklistAnswers: async (payload) => {
    try {
      const response = await axiosInstance.post(
        QUALITY_FRAMEWORK_ENDPOINTS.SUBMIT_CHECKLIST_ANSWERS,
        payload,
      );
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },

  // Get population count details
  getPopulationCountDetails: async (payload) => {
    try {
      const response = await axiosInstance.post(
        QUALITY_FRAMEWORK_ENDPOINTS.POPULATION_COUNT_DETAILS,
        payload,
      );
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },

  // Delete a record by ID
  deleteRecord: async (recordId) => {
    if (!recordId) {
      throw new Error("Record ID is required");
    }
    try {
      const response = await axiosInstance.delete(
        QUALITY_FRAMEWORK_ENDPOINTS.DELETE_RECORD(recordId),
      );
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },
};

export default QualityFrameworkService;
